import { render, staticRenderFns } from "./frmszolgkeres.vue?vue&type=template&id=4baed2fe&scoped=true&"
import script from "./frmszolgkeres.vue?vue&type=script&lang=js&"
export * from "./frmszolgkeres.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4baed2fe",
  null
  
)

export default component.exports